export const genderId: {
  male: 'male';
  female: 'female';
} = {
  male: 'male',
  female: 'female',
};

export const genderNames = {
  male: 'Male',
  female: 'Female',
};

export type GenderID = keyof typeof genderId;
